(() => {
  const parameterNames = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
  ];
  const storageKey = 'framelune_campaign_attribution';
  const affiliateStorageKey = 'framelune_affiliate_attribution';
  const currentParameters = new URLSearchParams(window.location.search);
  let attribution = {};

  const numericRef = currentParameters.get('ref') || '';
  const channelCode = currentParameters.get('fl_ch') || '';
  const referralToken = (/^[A-Za-z0-9]{10}$/.test(channelCode) ? `flch:${channelCode}` : '') || currentParameters.get('fl_channel') || currentParameters.get('fl_ref') || (/^\d{12}$/.test(numericRef) ? numericRef : '');
  const isReferralCode = (value) => /^[a-z0-9_-]{2,40}$/.test(value || '');
  const readReferralExpiry = (value) => {
    if (/^flch:[A-Za-z0-9]{10}$/.test(value || '')) return Number.MAX_SAFE_INTEGER;
    if (!value || value.length > 600 || !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value)) return 0;
    try {
      const encoded = value.split('.')[0].replaceAll('-', '+').replaceAll('_', '/');
      const payload = JSON.parse(atob(encoded + '='.repeat((4 - encoded.length % 4) % 4)));
      const expiry = Number(payload.e) * 1000;
      if (payload.v === 1 && /^[a-f0-9]{32}$/.test(payload.h || '') && payload.e === 0) return Number.MAX_SAFE_INTEGER;
      return payload.v === 1 && Number.isFinite(expiry) && expiry > Date.now() && expiry < Date.now() + 31 * 86400000 ? expiry : 0;
    } catch (_error) {
      return 0;
    }
  };

  if (referralToken) {
    const expiresAt = readReferralExpiry(referralToken);
    if (expiresAt || isReferralCode(referralToken)) {
      try {
        window.localStorage.setItem(affiliateStorageKey, JSON.stringify({
          token: referralToken,
          expiresAt: expiresAt || Date.now() + 30 * 86400000,
        }));
      } catch (_error) {
        // Continue without persistence when browser storage is unavailable.
      }
    }
  }

  let affiliateToken = readReferralExpiry(referralToken) || isReferralCode(referralToken) ? referralToken : '';
  if (!affiliateToken) {
    try {
      const saved = JSON.parse(window.localStorage.getItem(affiliateStorageKey) || '{}');
      if (saved.expiresAt > Date.now() && (readReferralExpiry(saved.token) || isReferralCode(saved.token))) affiliateToken = saved.token;
      else window.localStorage.removeItem(affiliateStorageKey);
    } catch (_error) {
      affiliateToken = '';
    }
  }

  if (affiliateToken) {
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { __fl_affiliate_token: affiliateToken } }),
      credentials: 'same-origin',
    }).catch(() => {});
  }

  try {
    attribution = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
  } catch (_error) {
    attribution = {};
  }

  let hasNewAttribution = false;
  for (const name of parameterNames) {
    const value = currentParameters.get(name);
    if (!value || value.length > 300) continue;
    attribution[name] = value;
    hasNewAttribution = true;
  }

  if (hasNewAttribution) {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(attribution));
    } catch (_error) {
      // Continue without persistence when browser storage is unavailable.
    }
  }

  if (!Object.keys(attribution).length) return;

  const shouldDecorate = (url) => {
    if (url.origin !== window.location.origin) return false;
    return /^\/(products|collections|pages)\//.test(url.pathname) || url.pathname === '/cart';
  };

  const decorateLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      if (!shouldDecorate(url)) return;

      for (const [name, value] of Object.entries(attribution)) {
        if (!url.searchParams.has(name)) url.searchParams.set(name, value);
      }

      link.href = url.toString();
    });
  };

  const start = () => {
    decorateLinks();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('a[href]')) decorateLinks(node.parentElement || node);
          else decorateLinks(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
